/**
 * Unit picker box — a control in the card header row, not a label on the plot. Sizes are from the
 * design spec (§4) rather than Button's own, which are a few px taller.
 */
export const UNIT_PICKER_CLASS =
    "h-[24px] gap-1 rounded-[7px] px-[8px] font-semibold text-[11px] text-muted-foreground sm:h-[26px]";

/** Sized by class, not the size prop: Button's svg rule beats the attribute. */
export const UNIT_PICKER_CHEVRON_CLASS = "size-[9px] opacity-75";
